import { Card, CardContent, Stack } from '@mui/joy';
import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Form, FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { Color, Variant } from 'theme/enums';

import { PartNoteType } from './enums';
import { IPartNoteForm } from './types';
import { getNoteLabel } from './utils';

interface IProps {
  isOpen?: boolean;
  level?: number;
  onClose?: (reset?: UseFormReset<IPartNoteForm>, closeSelection?: boolean) => void;
  onSubmit?: (reset?: UseFormReset<IPartNoteForm>) => (data: IPartNoteForm) => void;
  types: PartNoteType[] | string[];
}

export const AddPartNoteFormFields = ({
  isOpen = false,
  level,
  onClose,
  onSubmit,
  types,
}: IProps) => {
  const { t } = useTranslation();

  const { watch, control, errors } = useFormContext();

  const noteFormFields = types.map((type: PartNoteType | string) => {
    const label = getNoteLabel(type);

    const isEnabled = watch(`notes.${type}.enabled`);

    return (
      <Card key={type} color={Color.NEUTRAL} variant={Variant.PLAIN}>
        <CardContent>
          <Stack gap={1}>
            <FormField
              key={`${type}-enabled`}
              name={`notes.${type}.enabled`}
              type={InputType.CHECKBOX}
              inputProps={{
                control,
                error: errors?.notes?.[type]?.enabled,
                label,
                sx: { width: '100%' },
              }}
            />
            {isEnabled && (
              <FormField
                key={`${type}-content`}
                name={`notes.${type}.content`}
                type={InputType.TEXT_EDITOR}
                inputProps={{
                  control,
                  error: errors?.notes?.[type]?.content,
                  height: 200,
                }}
              />
            )}
          </Stack>
        </CardContent>
      </Card>
    );
  });

  return (
    <Form
      title={t('titleCreateNote')}
      level={level}
      isOpen={isOpen}
      onClose={onClose}
      submitBtnLabel={t('labelCreateNote')}
      onSubmit={onSubmit}
    >
      <Stack sx={{ gap: 'inherit', padding: '24px 0' }}>{noteFormFields}</Stack>
    </Form>
  );
};
